import {HTMLAttributes} from 'react';

interface IconfontProps extends HTMLAttributes<any> {
    className: string;
}

export const Iconfont: React.FC<IconfontProps> = props => {
    const {className, ...rest} = props;
    return <em className={'iconfont ' + className} {...rest}/>;
};

export default Iconfont;